/**
 * bfcache対策
 * ページをキャッシュから読み込むとevent.persistedがtrueになってリロードされる
 * APIのある画面やセキュアな画面はすべていれること
 * エラー画面など情報表示のみの画面は不要
 */
export function reloadOnPageShow() {
  window.onpageshow = (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  };
}
